import type { LocateAccount } from '@thinkalpha/ui-types/contracts/locates/platforms';
import { isEqual } from 'es-toolkit';

/**
 * Safety-net equality check for LocatesRowDataSourceWorkerProvider.updateAccounts.
 *
 * Returns true when the account list is deeply equal to the previous one, in
 * which case the provider can skip the expensive recreateDataSource cycle.
 * Uses deep equality (rather than id-only) because downstream consumers —
 * notably the account sort comparator in src/queries/locatesV2/sorts.ts —
 * snapshot fields like `name` into closed-over maps at comparator construction
 * time. Any field change that could affect sort, filter, or worker behavior
 * must force a recreate.
 *
 * Returns false on the first call (when prev is undefined) so the initial
 * data-source creation always runs.
 */
export function areAccountsUnchanged(prev: LocateAccount[] | undefined, next: LocateAccount[]): boolean {
    return prev !== undefined && isEqual(prev, next);
}
